export default __webpack_public_path__ + "static/media/kaus-mac.86db3080.png";